import { FC } from "react";

import Switch, { SwitchProps } from "@mui/material/Switch";

import { CUSTOM_SWITCH_TYPES } from "enums/customSwitchTypes";

import styles from "./styles";

type MintChoiceSwitchProps = {
  disabledLabel?: string;
  enabledLabel?: string;
  switchProps: SwitchProps;
  type?: CUSTOM_SWITCH_TYPES;
  buttonTextColorHex?: string;
};

const MintChoiceSwitch: FC<MintChoiceSwitchProps> = ({
  disabledLabel = "",
  enabledLabel = "",
  switchProps,
  buttonTextColorHex,
  type = CUSTOM_SWITCH_TYPES.PRIMARY,
}) => {
  return (
    <Switch
      {...switchProps}
      sx={[
        ...(type === CUSTOM_SWITCH_TYPES.PRIMARY
          ? [
              (theme) =>
                styles.primary(theme, {
                  disabledLabel,
                  enabledLabel,
                  buttonTextColorHex:
                    buttonTextColorHex || `${theme.palette.text.primary}`,
                }),
            ]
          : []),
      ]}
    />
  );
};

export default MintChoiceSwitch;
